// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.onboarding-container {
  display: grid;
  grid-template-columns: 1fr 2fr;
  background-color: white !important;
  height: 100%;
}

.onboarding-language-selector ::ng-deep .p-dropdown {
  box-shadow: none !important;
  background-color: white !important;
}

::ng-deep .onboarding-modal .p-dialog-header {
  display: none;
}

::ng-deep .onboarding-modal {
  min-height: 800px;
  max-height: 800px;
  background-color: white !important;
  border-radius: 2rem !important;
  overflow: hidden;
}

::ng-deep .onboarding-modal .p-dialog-content {
  padding: 0 !important;
  padding-right: 20px !important;
  background-color: white !important;
  overflow-y: hidden !important;
  overflow-x: hidden !important;
}

.wave-content {
  height: 100px;
}

.element-1 {
  position: relative;
  bottom: 190px;
}

.element-2 {
  position: relative;
  bottom: 95px;
}

.element-3 {
  position: relative;
  top: 0px;
  border-top-left-radius: 8px;
}

.bottom-element-1 {
  position: relative;
  bottom: 46px;
}

.bottom-element-2 {
  position: relative;
  bottom: 140px;
}

.bottom-element-3 {
  position: relative;
  bottom: 235px;
  border-bottom-left-radius: 8px;
}

.onboardwelcome {
  background-color: white;
  border-radius: 10px;
  padding: 1rem 1rem 1rem 3rem;
  text-align: left;
  max-width: 300px;
}

.onboardwelcome h1 {
  font-size: 24px;
  color: var(--primary-color);
  margin-bottom: 10px;
}

.onboardwelcome p {
  font-size: 16px;
  color: #333;
  margin-bottom: 20px;
}

.right-column {
  padding: 3rem 0rem;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
}
.right-column .right-column--header {
  flex-shrink: 0;
}
.right-column .right-column--body {
  flex: 1;
  overflow-y: visible;
  position: relative;
  z-index: 1;
}
.right-column .right-column--body h5 {
  margin: 0.5rem 0;
}
.right-column .right-column--footer {
  flex-shrink: 0;
}

::ng-deep .custom-steps .p-steps-number {
  background-color: white !important;
  border: 1px solid #d3d3d3 !important;
  width: 50px;
  height: 50px !important;
  border-radius: 100% !important;
  font-weight: 200 !important;
}

::ng-deep .custom-steps .p-steps-item {
  cursor: pointer !important;
}

::ng-deep .custom-steps .p-steps-item.p-highlight .p-steps-number {
  border-color: var(--primary-color) !important;
  color: var(--primary-color) !important;
  font-weight: 600 !important;
}

.form {
  display: flex;
  flex-direction: column;
}

label {
  margin-bottom: 5px;
}

.button-container {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}

.footer-container {
  position: absolute;
  top: 88%;
  width: 67%;
}

button {
  padding: 10px 20px;
  font-size: 16px;
  border-radius: 5px;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
}

button .material-symbols-outlined {
  margin-bottom: 0.15rem;
}

.back-button {
  background-color: transparent;
  color: var(--primary-color);
  border: none;
  font-weight: bold;
  padding-left: 0px;
}

.back-button i {
  margin-right: 5px;
}

.next-button,
.submit-button {
  background-color: var(--primary-color);
  color: white;
  font-weight: bold;
}

.next-button i,
.submit-button i {
  margin-left: 5px;
}

button:disabled {
  background-color: #ccc;
  color: white;
  cursor: not-allowed;
}

button i {
  font-size: 12px;
}

:host ::ng-deep .scan-spinner .p-progress-spinner-circle {
  animation: scan 8s ease-in-out infinite;
}

@keyframes scan {
  100%, 0% {
    stroke: rgb(88, 88, 88);
  }
  40% {
    stroke: rgb(88, 88, 88);
  }
  66% {
    stroke: rgb(88, 88, 88);
  }
  80%, 90% {
    stroke: rgb(88, 88, 88);
  }
}
.freetrial {
  background-color: white;
  padding: 20px;
  text-align: center;
  max-width: 300px;
  height: 510px;
}

.freetrial h1 {
  font-size: 24px;
  color: var(--primary-color);
}

.freetrial p {
  font-size: 1rem;
  color: #333;
}

.benefits {
  list-style-type: none;
  padding: 0;
  margin-bottom: 20px 0;
}

.benefits li {
  display: flex;
  align-items: center;
  font-size: 1rem;
  margin-bottom: 10px;
  color: #333;
}

.benefits li .material-symbols-outlined {
  color: var(--primary-color);
  margin-bottom: 0.15rem;
}

.buttonPricing {
  display: inline-block;
  padding: 0.4rem;
  font-size: 16px;
  color: var(--primary-color);
  border: 2px solid var(--primary-color);
  border-radius: 5px;
  text-decoration: none;
  transition: background-color 0.3s ease, color 0.3s ease;
  cursor: pointer;
  margin-top: 15px;
}

.buttonPricing:hover {
  background-color: var(--primary-color);
  color: white;
}

.tooltip {
  font-size: 12px;
  color: #888;
  margin-left: 5px;
}

.dotted-line {
  border-bottom: 2px dotted grey;
  /* Adjust thickness and color */
  width: 30px;
  /* Adjust length */
  margin-top: 20px;
  transform: rotate(80deg);
  /* Space between elements */
}

.curved-dotted-line {
  width: 20px;
  /* Adjust width */
  height: 10px;
  /* Adjust height */
}

.arrow {
  height: 2.5rem;
}

.features {
  list-style-type: none;
  padding: 0;
}
.features ul {
  margin-top: 13px;
}
.features svg {
  margin-right: 20px;
}

.features li {
  display: flex;
  align-items: center;
  font-size: 16px;
  margin-bottom: 0px;
  margin-top: 0px;
  color: #333;
}

li {
  margin-top: 20px;
}

.features li svg {
  margin-right: 10px;
  width: 24px;
  height: 24px;
}

.features li span {
  color: var(--primary-color);
}`, "",{"version":3,"sources":["webpack://./src/app/main/apps/components/onboarding/onboarding.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,8BAAA;EACA,kCAAA;EACA,YAAA;AACJ;;AAGI;EACI,2BAAA;EACA,kCAAA;AAAR;;AAIA;EACI,aAAA;AADJ;;AAIA;EACI,iBAAA;EACA,iBAAA;EACA,kCAAA;EACA,8BAAA;EACA,gBAAA;AADJ;;AAIA;EACI,qBAAA;EACA,8BAAA;EACA,kCAAA;EACA,6BAAA;EACA,6BAAA;AADJ;;AAOA;EACI,aAAA;AAJJ;;AAOA;EACI,kBAAA;EACA,aAAA;AAJJ;;AAQA;EACI,kBAAA;EACA,YAAA;AALJ;;AAQA;EACI,kBAAA;EACA,QAAA;EACA,2BAAA;AALJ;;AAQA;EACI,kBAAA;EACA,YAAA;AALJ;;AAQA;EACI,kBAAA;EACA,aAAA;AALJ;;AAQA;EACI,kBAAA;EACA,aAAA;EACA,8BAAA;AALJ;;AAQA;EACI,uBAAA;EACA,mBAAA;EACA,4BAAA;EACA,gBAAA;EACA,gBAAA;AALJ;;AAQA;EACI,eAAA;EACA,2BAAA;EACA,mBAAA;AALJ;;AAQA;EACI,eAAA;EACA,WAAA;EACA,mBAAA;AALJ;;AAQA;EACI,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;AALJ;AAOI;EACI,cAAA;AALR;AAQI;EACI,OAAA;EACA,mBAAA;EACA,kBAAA;EACA,UAAA;AANR;AAQQ;EACI,gBAAA;AANZ;AAUI;EACI,cAAA;AARR;;AAYA;EACI,kCAAA;EACA,oCAAA;EACA,WAAA;EACA,uBAAA;EACA,8BAAA;EACA,2BAAA;AATJ;;AAYA;EACI,0BAAA;AATJ;;AAaA;EACI,6CAAA;EACA,sCAAA;EACA,2BAAA;AAVJ;;AAcA;EACI,aAAA;EACA,sBAAA;AAXJ;;AAcA;EACI,kBAAA;AAXJ;;AAeA;EACI,aAAA;EACA,8BAAA;EACA,gBAAA;AAZJ;;AAeA;EACI,kBAAA;EACA,QAAA;EACA,UAAA;AAZJ;;AAgBA;EACI,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;AAbJ;;AAgBA;EACI,sBAAA;AAbJ;;AAgBA;EACI,6BAAA;EACA,2BAAA;EACA,YAAA;EACA,iBAAA;EACA,iBAAA;AAbJ;;AAgBA;EACI,iBAAA;AAbJ;;AAgBA;;EAEI,sCAAA;EACA,YAAA;EACA,iBAAA;AAbJ;;AAgBA;;EAEI,gBAAA;AAbJ;;AAqBA;EACI,sBAAA;EACA,YAAA;EACA,mBAAA;AAlBJ;;AAqBA;EACI,eAAA;AAlBJ;;AAqBA;EACI,uCAAA;AAlBJ;;AAqBA;EAEI;IAEI,uBAAA;EApBN;EAuBE;IACI,uBAAA;EArBN;EAwBE;IACI,uBAAA;EAtBN;EAyBE;IAEI,uBAAA;EAxBN;AACF;AA2BA;EACI,uBAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;AAzBJ;;AA4BA;EACI,eAAA;EACA,2BAAA;AAzBJ;;AA4BA;EACI,eAAA;EACA,WAAA;AAzBJ;;AA4BA;EACI,qBAAA;EACA,UAAA;EACA,qBAAA;AAzBJ;;AA4BA;EACI,aAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;EACA,WAAA;AAzBJ;;AA4BA;EACI,2BAAA;EACA,sBAAA;AAzBJ;;AA+BA;EACI,qBAAA;EACA,eAAA;EACA,eAAA;EACA,2BAAA;EACA,sCAAA;EACA,kBAAA;EACA,qBAAA;EACA,uDAAA;EACA,eAAA;EACA,gBAAA;AA5BJ;;AA+BA;EACI,sCAAA;EACA,YAAA;AA5BJ;;AA+BA;EACI,eAAA;EACA,WAAA;EACA,gBAAA;AA5BJ;;AA+BA;EACI,8BAAA;EACA,+BAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,wBAAA;EACA,2BAAA;AA5BJ;;AA+BA;EACI,WAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;AA5BJ;;AA+BA;EACI,cAAA;AA5BJ;;AAgCA;EACI,qBAAA;EACA,UAAA;AA7BJ;AA+BI;EACI,gBAAA;AA7BR;AAgCI;EACI,kBAAA;AA9BR;;AAkCA;EACI,aAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,eAAA;EACA,WAAA;AA/BJ;;AAkCA;EACI,gBAAA;AA/BJ;;AAkCA;EACI,kBAAA;EACA,WAAA;EACA,YAAA;AA/BJ;;AAmCA;EACI,2BAAA;AAhCJ","sourcesContent":[".onboarding-container {\n    display: grid;\n    grid-template-columns: 1fr 2fr;\n    background-color: white !important;\n    height: 100%;\n}\n\n.onboarding-language-selector {\n    ::ng-deep .p-dropdown {\n        box-shadow: none !important;\n        background-color: white !important;\n    }\n}\n\n::ng-deep .onboarding-modal .p-dialog-header {\n    display: none;\n}\n\n::ng-deep .onboarding-modal {\n    min-height: 800px;\n    max-height: 800px;\n    background-color: white !important;\n    border-radius: 2rem !important;\n    overflow: hidden;\n}\n\n::ng-deep .onboarding-modal .p-dialog-content {\n    padding: 0 !important;\n    padding-right: 20px !important;\n    background-color: white !important;\n    overflow-y: hidden !important;\n    overflow-x: hidden !important;\n\n}\n\n.container {}\n\n.wave-content {\n    height: 100px;\n}\n\n.element-1 {\n    position: relative;\n    bottom: 190px;\n\n}\n\n.element-2 {\n    position: relative;\n    bottom: 95px\n}\n\n.element-3 {\n    position: relative;\n    top: 0px;\n    border-top-left-radius: 8px;\n}\n\n.bottom-element-1 {\n    position: relative;\n    bottom: 46px;\n}\n\n.bottom-element-2 {\n    position: relative;\n    bottom: 140px;\n}\n\n.bottom-element-3 {\n    position: relative;\n    bottom: 235px;\n    border-bottom-left-radius: 8px;\n}\n\n.onboardwelcome {\n    background-color: white;\n    border-radius: 10px;\n    padding: 1rem 1rem 1rem 3rem;\n    text-align: left;\n    max-width: 300px;\n}\n\n.onboardwelcome h1 {\n    font-size: 24px;\n    color: var(--primary-color);\n    margin-bottom: 10px;\n}\n\n.onboardwelcome p {\n    font-size: 16px;\n    color: #333;\n    margin-bottom: 20px;\n}\n\n.right-column {\n    padding: 3rem 0rem;\n    display: flex;\n    flex-direction: column;\n    overflow-y: auto;\n\n    .right-column--header {\n        flex-shrink: 0;\n    }\n\n    .right-column--body {\n        flex: 1;\n        overflow-y: visible;\n        position: relative;\n        z-index: 1;\n\n        h5 {\n            margin: 0.5rem 0;\n        }\n    }\n\n    .right-column--footer {\n        flex-shrink: 0;\n    }\n}\n\n::ng-deep .custom-steps .p-steps-number {\n    background-color: white !important;\n    border: 1px solid #d3d3d3 !important;\n    width: 50px;\n    height: 50px !important;\n    border-radius: 100% !important;\n    font-weight: 200 !important;\n}\n\n::ng-deep .custom-steps .p-steps-item {\n    cursor: pointer !important;\n\n}\n\n::ng-deep .custom-steps .p-steps-item.p-highlight .p-steps-number {\n    border-color: var(--primary-color) !important;\n    color: var(--primary-color) !important;\n    font-weight: 600 !important;\n\n}\n\n.form {\n    display: flex;\n    flex-direction: column;\n}\n\nlabel {\n    margin-bottom: 5px;\n}\n\n\n.button-container {\n    display: flex;\n    justify-content: space-between;\n    margin-top: 20px;\n}\n\n.footer-container {\n    position: absolute;\n    top: 88%;\n    width: 67%;\n}\n\n\nbutton {\n    padding: 10px 20px;\n    font-size: 16px;\n    border-radius: 5px;\n    border: none;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n}\n\nbutton .material-symbols-outlined {\n    margin-bottom: 0.15rem;\n}\n\n.back-button {\n    background-color: transparent;\n    color: var(--primary-color);\n    border: none;\n    font-weight: bold;\n    padding-left: 0px;\n}\n\n.back-button i {\n    margin-right: 5px;\n}\n\n.next-button,\n.submit-button {\n    background-color: var(--primary-color);\n    color: white;\n    font-weight: bold;\n}\n\n.next-button i,\n.submit-button i {\n    margin-left: 5px;\n}\n\n// .next-button:hover,\n// .submit-button:hover {\n//     background-color: #1565c0;\n// }\n\nbutton:disabled {\n    background-color: #ccc;\n    color: white;\n    cursor: not-allowed;\n}\n\nbutton i {\n    font-size: 12px;\n}\n\n:host ::ng-deep .scan-spinner .p-progress-spinner-circle {\n    animation: scan 8s ease-in-out infinite;\n}\n\n@keyframes scan {\n\n    100%,\n    0% {\n        stroke: rgb(88, 88, 88)\n    }\n\n    40% {\n        stroke: rgb(88, 88, 88)\n    }\n\n    66% {\n        stroke: rgb(88, 88, 88)\n    }\n\n    80%,\n    90% {\n        stroke: rgb(88, 88, 88)\n    }\n}\n\n.freetrial {\n    background-color: white;\n    padding: 20px;\n    text-align: center;\n    max-width: 300px;\n    height: 510px\n}\n\n.freetrial h1 {\n    font-size: 24px;\n    color: var(--primary-color);\n}\n\n.freetrial p {\n    font-size: 1rem;\n    color: #333;\n}\n\n.benefits {\n    list-style-type: none;\n    padding: 0;\n    margin-bottom: 20px 0;\n}\n\n.benefits li {\n    display: flex;\n    align-items: center;\n    font-size: 1rem;\n    margin-bottom: 10px;\n    color: #333;\n}\n\n.benefits li .material-symbols-outlined {\n    color: var(--primary-color);\n    margin-bottom: 0.15rem;\n}\n\n\n\n\n.buttonPricing {\n    display: inline-block;\n    padding: 0.4rem;\n    font-size: 16px;\n    color: var(--primary-color);\n    border: 2px solid var(--primary-color);\n    border-radius: 5px;\n    text-decoration: none;\n    transition: background-color 0.3s ease, color 0.3s ease;\n    cursor: pointer;\n    margin-top: 15px;\n}\n\n.buttonPricing:hover {\n    background-color: var(--primary-color);\n    color: white;\n}\n\n.tooltip {\n    font-size: 12px;\n    color: #888;\n    margin-left: 5px;\n}\n\n.dotted-line {\n    border-bottom: 2px dotted grey;\n    /* Adjust thickness and color */\n    width: 30px;\n    /* Adjust length */\n    margin-top: 20px;\n    transform: rotate(80deg);\n    /* Space between elements */\n}\n\n.curved-dotted-line {\n    width: 20px;\n    /* Adjust width */\n    height: 10px;\n    /* Adjust height */\n}\n\n.arrow {\n    height: 2.5rem;\n}\n\n\n.features {\n    list-style-type: none;\n    padding: 0;\n\n    ul {\n        margin-top: 13px\n    }\n\n    svg {\n        margin-right: 20px;\n    }\n}\n\n.features li {\n    display: flex;\n    align-items: center;\n    font-size: 16px;\n    margin-bottom: 0px;\n    margin-top: 0px;\n    color: #333;\n}\n\nli {\n    margin-top: 20px;\n}\n\n.features li svg {\n    margin-right: 10px;\n    width: 24px;\n    height: 24px;\n}\n\n\n.features li span {\n    color: var(--primary-color);\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
